import { UseTranslationResponse } from 'react-i18next';
import { TOptions } from 'i18next';

export const tDynamic = (
  i18n: Pick<UseTranslationResponse<any, any>, 't'>,
  key: string,
  options?: TOptions,
) => {
  return i18n.t(key, options);
};
